import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/auth'
import getConfig from 'next/config'
const {
  firebaseProjectId,
  firebaseSenderId,
  firebaseApiKey,
} = getConfig().publicRuntimeConfig

if (!firebase.apps.length) {
  const projectId = firebaseProjectId

  firebase.initializeApp({
    projectId,
    apiKey: firebaseApiKey,
    authDomain: `${projectId}.firebaseapp.com`,
    databaseURL: `https://${projectId}.firebaseio.com`,
    storageBucket: `${projectId}.appspot.com`,
    messagingSenderId: firebaseSenderId,
  })
}

export default firebase
